export const FETCHED_SHIPPING_TABLE = '@app/shipping/fetchedShippingTableAction';
export const FETCHING_SHIPPING_TABLE = '@app/shipping/fetchingShippingTableAction';

/**
 * @typedef {Object} DeliveryService
 * @property {string} carrierName
 * @property {string} deliveryTime
 * @property {number} price
 */

/**
 * @param {Object[]} countries
 * @return {{type: string, countries: Object[]}}
 */
export const fetchedShippingTableAction = (countries) => ({
	type: FETCHED_SHIPPING_TABLE,
	countries
});

export const fetchingShippingTableAction = () => ({
	type: FETCHING_SHIPPING_TABLE
});



// WEBPACK FOOTER //
// ./actions/ShippingPageActions.js